import Raven from 'raven-js';

Raven.config(process.env.REACT_APP_SENTRY_DSN, {
  whitelistUrls: [ /imageresize\.org/ ] // ignore errors caused by ads and other third-party scripts
}).install();

Raven.clog = function(error, page) {
  if(typeof error === 'string') {
    if(error.indexOf('uploading') !== -1) {
      error = 'File uploading error.';
    } else if (error.indexOf('undefined') !== -1) {
      error = 'File type undefined.';
    } else if (error.indexOf('supported') !== -1) {
      let ext = error.match(/\.[a-z]+/);
      if(ext[0]) {
        error = ext[0].replace('.', '').toUpperCase() + ' is not supported.';
      }
    } else if (error.indexOf('maximum') !== -1) {
      error = 'File size limit exceeded.';
    }
  }
  Raven.captureException(error + ' Page: ' + page);
  Raven.showReportDialog();
}

export default Raven;


// WEBPACK FOOTER //
// ./src/modules/raven.js